// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2qTH7","vLegacy":"SelectSecondary_vLegacy__2BCCH","error":"SelectSecondary_error__1JTZB","disabled":"SelectSecondary_disabled__1rd9L"};